import React from 'react';
import Card from 'src/components/atomic/atoms/card/Card';
import Circle from 'src/components/atomic/atoms/circle/Circle';
import ConnectAccountsButton from 'src/components/atomic/atoms/connectAccountsButton/ConnectAccountsButton';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import Typography from 'src/components/typography/Typography';
import { CalloutViewModel } from 'src/types/view-models/atoms/callout.view.model';

import bgColors from 'src/styles/bgColors.module.scss';
import styleVars from 'src/styles/variables.module.scss';
import styles from './callout.module.scss';

/** Callout bluebox component, must be used within PlaidContext unless withButton is false */
export default function Callout({
    icon,
    heading,
    body,
    withButton = true,
    className,
    children,
    ...props
}: CalloutViewModel): JSX.Element {
    return (
        <Card
            className={`${styles.container} ${className}`}
            icon={
                icon ? (
                    <Circle
                        diameter={styleVars.calloutIconCircleDiameter}
                        className={`${styles.calloutIcon} ${bgColors.brand}`}
                    >
                        {icon}
                    </Circle>
                ) : undefined
            }
            heading={
                heading ? (
                    <Typography variant={TypographyVariants.HEADING_XS} component="p">
                        {heading}
                    </Typography>
                ) : undefined
            }
            showBackgroundBanner={false}
            {...props}
        >
            {body && <Typography variant={TypographyVariants.BODY}>{body}</Typography>}

            <>{children}</>

            {withButton && <ConnectAccountsButton />}
        </Card>
    );
}
